import type { CastParagraph } from './types';

/**
 * The kebab-case attribute names for list metadata on serialized `<p>`
 * elements (`<p list-level="1" list-type="numbered" list-marker="1.">`).
 * Single source of truth for the names: the cast serializer writes them
 * (`serializeParagraph`), the redline output parser (`html-to-aline`) and the
 * client's insert preview (`sanitize-html`) read them, and both LLM prompts
 * (`createCastContextPrompt` for input, `HTML_OUTPUT_FORMAT` for output)
 * document them.
 *
 * Keyed by the `CastParagraph` property each attribute serializes, so renaming
 * a property breaks the build here. The kebab values are wire format —
 * existing prompts and model behavior depend on them — so they are spelled out
 * rather than derived from the property names: renaming a TypeScript property
 * must not silently change the wire format.
 */
export const LIST_ATTRIBUTE_NAMES = {
  listLevel: 'list-level',
  listMarker: 'list-marker',
  listType: 'list-type',
} as const satisfies Record<
  keyof Pick<CastParagraph, 'listLevel' | 'listMarker' | 'listType'>,
  string
>;
